/**
 * 多言語対応 (i18n)
 */

import { messageTranslations } from './i18n_messages';

export const translations = {
  ja: {
    ...messageTranslations.ja,
    // Auth
    loginRequired: 'このアプリは Google ログインが必要です',
    loginWithGoogle: 'Google でログイン',
    loginWithLine: 'LINE でログイン',
    loggingIn: 'ログイン中...',
    externalScannerMode: '外部スキャナーモード',
    
    // Menu
    tickets: 'チケット',
    qrExpansion: 'QR枠購入',
    settings: '設定',
    externalScanner: '外部スキャナー',
    
    // Settings
    language: '言語',
    tipDeveloper: '開発者に投銭',
    logout: 'ログアウト',
    deleteAllData: 'データ全削除',
    
    // Tickets
    ticketList: 'チケット一覧',
    qrTotal: 'QR合計',
    noTickets: 'チケットがまだ作成されていません',
    createNewTicket: '新規チケット作成',
    ticketName: 'チケット名',
    create: '作成',
    creating: '作成中...',
    cancel: 'キャンセル',
    
    // Ticket Details
    ticketDetails: 'チケット詳細',
    issued: '発行済み(チェック済み/発行数)',
    expiryDate: '有効期限',
    qrOperations: 'QR操作',
    createQR: 'QR作成',
    readQR: 'QR読み取り',
    generate: '生成',
    generating: '生成中...',
    generateCount: '生成枚数',
    deleteTicket: 'チケットを削除',
    
    // QR Actions
    downloadCSV: 'CSVダウンロード',
    downloadImages: '画像ダウンロード',
    downloadPDF: 'PDF印刷用',
    
    // Subscription
    purchaseQR: 'QR枠購入（30日有効）',
    loading: '読み込み中...',
    daysRemaining: 'あと{days}日',
    addPurchase: '枠を追加購入',
    deleting: '削除中...',
    
    // Account
    userId: 'ユーザーID',
    keyId: 'キーID',
    authMethod: '認証方式',
    
    // Messages
    loginSuccess: '{name} でログインしました',
    logoutSuccess: 'Googleログインを解除し、初期生成IDに戻しました',
    ticketCreated: 'チケット「{name}」を作成しました',
    qrGenerated: '{count}個のQRコードを生成しました',
    
    // External Device
    externalDevicePermission: '外部デバイス許可',
    selectTicket: '設定対象のチケット',
    ticketId: 'チケットID',
    copy: 'コピー',
    allowExternalAccess: 'このチケットのQR読み取りを外部デバイスに許可する(🔓 外部スキャナーでスキャンできます)'
  },
  
  en: {
    ...messageTranslations.en,
    // Auth
    loginRequired: 'Google login required for this app',
    loginWithGoogle: 'Login with Google',
    loginWithLine: 'Login with LINE',
    loggingIn: 'Logging in...',
    externalScannerMode: 'External Scanner Mode',
    
    // Menu
    tickets: 'Tickets',
    qrExpansion: 'QR Slots',
    settings: 'Settings',
    externalScanner: 'Scanner',
    
    // Settings
    language: 'Language',
    tipDeveloper: 'Tip Developer',
    logout: 'Logout',
    deleteAllData: 'Delete All Data',
    
    // Tickets
    ticketList: 'Ticket List',
    qrTotal: 'QR Total',
    noTickets: 'No tickets created yet',
    createNewTicket: 'Create New Ticket',
    ticketName: 'Ticket Name',
    create: 'Create',
    creating: 'Creating...',
    cancel: 'Cancel',
    
    // Ticket Details
    ticketDetails: 'Ticket Details',
    issued: 'Issued (Checked/Total)',
    expiryDate: 'Expiry Date',
    qrOperations: 'QR Operations',
    createQR: 'Create QR',
    readQR: 'Read QR',
    generate: 'Generate',
    generating: 'Generating...',
    generateCount: 'Count',
    deleteTicket: 'Delete Ticket',
    
    // QR Actions
    downloadCSV: 'Download CSV',
    downloadImages: 'Download Images',
    downloadPDF: 'Download PDF',
    
    // Subscription
    purchaseQR: 'Purchase QR Slots (30 days)',
    loading: 'Loading...',
    daysRemaining: '{days} days left',
    addPurchase: 'Add Purchase',
    deleting: 'Deleting...',
    
    // Account
    userId: 'User ID',
    keyId: 'Key ID',
    authMethod: 'Auth Method',
    
    // Messages
    loginSuccess: 'Logged in as {name}',
    logoutSuccess: 'Logged out and returned to initial ID',
    ticketCreated: 'Ticket "{name}" created',
    qrGenerated: '{count} QR codes generated',
    
    // External Device
    externalDevicePermission: 'Device Access',
    selectTicket: 'Select Ticket',
    ticketId: 'Ticket ID',
    copy: 'Copy',
    allowExternalAccess: 'Allow external devices to scan this ticket'
  },
  
  ko: {
    ...messageTranslations.ko,
    // Auth
    loginRequired: '이 앱은 Google 로그인이 필요합니다',
    loginWithGoogle: 'Google로 로그인',
    loginWithLine: 'LINE으로 로그인',
    loggingIn: '로그인 중...',
    externalScannerMode: '외부 스캐너 모드',
    
    // Menu
    tickets: '티켓',
    qrExpansion: 'QR 확장',
    settings: '설정',
    externalScanner: '외부 스캐너',
    
    // Settings
    language: '언어',
    tipDeveloper: '개발자 후원',
    logout: '로그아웃',
    deleteAllData: '모든 데이터 삭제',
    
    // Tickets
    ticketList: '티켓 목록',
    qrTotal: 'QR 합계',
    noTickets: '아직 생성된 티켓이 없습니다',
    createNewTicket: '새 티켓 만들기',
    ticketName: '티켓 이름',
    create: '만들기',
    creating: '생성 중...',
    cancel: '취소',
    
    // Ticket Details
    ticketDetails: '티켓 상세',
    issued: '발행됨 (확인됨/총)',
    expiryDate: '만료일',
    qrOperations: 'QR 작업',
    createQR: 'QR 생성',
    readQR: 'QR 읽기',
    generate: '생성',
    generating: '생성 중...',
    generateCount: '생성 수',
    deleteTicket: '티켓 삭제',
    
    // QR Actions
    downloadCSV: 'CSV 다운로드',
    downloadImages: '이미지 다운로드',
    downloadPDF: 'PDF 다운로드',
    
    // Subscription
    purchaseQR: 'QR 슬롯 구매 (30일)',
    loading: '로딩 중...',
    daysRemaining: '{days}일 남음',
    addPurchase: '구매 추가',
    deleting: '삭제 중...',
    
    // Account
    userId: '사용자 ID',
    keyId: '키 ID',
    authMethod: '인증 방법',
    
    // Messages
    loginSuccess: '{name}(으)로 로그인했습니다',
    logoutSuccess: '로그아웃하고 초기 ID로 돌아갔습니다',
    ticketCreated: '티켓 "{name}"이(가) 생성되었습니다',
    qrGenerated: '{count}개의 QR 코드가 생성되었습니다',
    
    // External Device
    externalDevicePermission: '외부 장치 권한',
    selectTicket: '티켓 선택',
    ticketId: '티켓 ID',
    copy: '복사',
    allowExternalAccess: '외부 장치에서 이 티켓을 스캔할 수 있도록 허용'
  },
  
  zh: {
    ...messageTranslations.zh,
    // Auth
    loginRequired: '此应用需要 Google 登录',
    loginWithGoogle: '使用 Google 登录',
    loginWithLine: '使用 LINE 登录',
    loggingIn: '登录中...',
    externalScannerMode: '外部扫描仪模式',
    
    // Menu
    tickets: '票券',
    qrExpansion: 'QR 扩展',
    settings: '设置',
    externalScanner: '外部扫描仪',
    
    // Settings
    language: '语言',
    tipDeveloper: '打赏开发者',
    logout: '登出',
    deleteAllData: '删除所有数据',
    
    // Tickets
    ticketList: '票券列表',
    qrTotal: 'QR 总计',
    noTickets: '尚未创建票券',
    createNewTicket: '创建新票券',
    ticketName: '票券名称',
    create: '创建',
    creating: '创建中...',
    cancel: '取消',
    
    // Ticket Details
    ticketDetails: '票券详情',
    issued: '已发行（已检查/总数）',
    expiryDate: '到期日期',
    qrOperations: 'QR 操作',
    createQR: '创建 QR',
    readQR: '读取 QR',
    generate: '生成',
    generating: '生成中...',
    generateCount: '生成数量',
    deleteTicket: '删除票券',
    
    // QR Actions
    downloadCSV: '下载 CSV',
    downloadImages: '下载图片',
    downloadPDF: '下载 PDF',
    
    // Subscription
    purchaseQR: '购买 QR 槽位（30天）',
    loading: '加载中...',
    daysRemaining: '剩余 {days} 天',
    addPurchase: '添加购买',
    deleting: '删除中...',
    
    // Account
    userId: '用户 ID',
    keyId: '密钥 ID',
    authMethod: '认证方式',
    
    // Messages
    loginSuccess: '已登录为 {name}',
    logoutSuccess: '已登出并返回初始 ID',
    ticketCreated: '票券 "{name}" 已创建',
    qrGenerated: '已生成 {count} 个 QR 码',
    
    // External Device
    externalDevicePermission: '外部设备权限',
    selectTicket: '选择票券',
    ticketId: '票券 ID',
    copy: '复制',
    allowExternalAccess: '允许外部设备扫描此票券'
  }
};

export const getTranslation = (lang, key) => {
  const langData = translations[lang] || translations.en;
  return langData[key] || translations.en[key] || key;
};

export const formatMessage = (lang, key, params = {}) => {
  let message = getTranslation(lang, key);
  Object.keys(params).forEach(param => {
    message = message.replace(`{${param}}`, params[param]);
  });
  return message;
};


// Additional translations for TicketPanel
// Japanese
translations.ja.entryManagement = '入場管理';
translations.ja.entryStatus = '入場状況';
translations.ja.designPDF = 'デザイン付きPDF';
translations.ja.csvImport = 'CSVインポート';
translations.ja.refreshSync = '最新に更新（WEB同期）';
translations.ja.purchaseSlots = '枠を購入';
translations.ja.remainingSlots = '残り枠数';
translations.ja.usedSlots = '使用済み';
translations.ja.totalSlots = '合計枠数';
translations.ja.qrCodeList = 'QRコード一覧';
translations.ja.entryTime = '入場時刻';
translations.ja.entryDevice = '入場デバイス';
translations.ja.entered = '入場済み';
translations.ja.notEntered = '未入場';
translations.ja.all = 'すべて';
translations.ja.filter = 'フィルター';
translations.ja.search = '検索';
translations.ja.freeText = 'フリー入力';
translations.ja.scanQR = 'QRスキャン';
translations.ja.manualInput = '手動入力';
translations.ja.cameraMode = 'カメラモード';
translations.ja.selectTemplate = 'テンプレート選択';
translations.ja.modern = 'モダン';
translations.ja.classic = 'クラシック';
translations.ja.pop = 'ポップ';
translations.ja.eventInfo = 'イベント情報';
translations.ja.eventDate = 'イベント日時';
translations.ja.venue = '会場';
translations.ja.seatInfo = '座席情報';
translations.ja.layout = 'レイアウト';
translations.ja.a4Layout = 'A4レイアウト';
translations.ja.individual = '1枚ずつ';
translations.ja.mobileLayout = '携帯用縦レイアウト';
translations.ja.preview = 'プレビュー';
translations.ja.generatePDF = 'PDF生成';
translations.ja.close = '閉じる';
translations.ja.confirm = '確認';
translations.ja.delete = '削除';
translations.ja.edit = '編集';
translations.ja.save = '保存';
translations.ja.back = '戻る';
translations.ja.next = '次へ';
translations.ja.finish = '完了';
translations.ja.error = 'エラー';
translations.ja.success = '成功';
translations.ja.warning = '警告';
translations.ja.info = '情報';
translations.ja.downloadLimit = 'WEB版は1日1回までダウンロード可能です。';
translations.ja.downloadApp = '制限なしで使用するには、デスクトップアプリをダウンロードしてください。';
translations.ja.openDownloadPage = 'ダウンロードページを開きますか？';
translations.ja.cooldownMessage = '連続ダウンロード制限: {seconds}秒後に再試行してください';
translations.ja.paymentCancelled = '決済をキャンセルしました';
translations.ja.paymentSuccess = '決済が完了しました';
translations.ja.syncSuccess = '同期が完了しました';
translations.ja.deleteConfirm = '本当に削除しますか？';
translations.ja.deleteAllDataConfirm = '全てのデータを削除しますか？この操作は取り消せません。';

// English
translations.en.entryManagement = 'Entry';
translations.en.entryStatus = 'Status';
translations.en.designPDF = 'Design PDF';
translations.en.csvImport = 'CSV Import';
translations.en.refreshSync = 'Refresh (WEB Sync)';
translations.en.purchaseSlots = 'Purchase Slots';
translations.en.remainingSlots = 'Remaining Slots';
translations.en.usedSlots = 'Used';
translations.en.totalSlots = 'Total Slots';
translations.en.qrCodeList = 'QR Code List';
translations.en.entryTime = 'Entry Time';
translations.en.entryDevice = 'Entry Device';
translations.en.entered = 'Entered';
translations.en.notEntered = 'Not Entered';
translations.en.all = 'All';
translations.en.filter = 'Filter';
translations.en.search = 'Search';
translations.en.freeText = 'Free Text';
translations.en.scanQR = 'Scan QR';
translations.en.manualInput = 'Manual Input';
translations.en.cameraMode = 'Camera Mode';
translations.en.selectTemplate = 'Select Template';
translations.en.modern = 'Modern';
translations.en.classic = 'Classic';
translations.en.pop = 'Pop';
translations.en.eventInfo = 'Event Info';
translations.en.eventDate = 'Event Date';
translations.en.venue = 'Venue';
translations.en.seatInfo = 'Seat Info';
translations.en.layout = 'Layout';
translations.en.a4Layout = 'A4 Layout';
translations.en.individual = 'Individual';
translations.en.mobileLayout = 'Mobile Vertical Layout';
translations.en.preview = 'Preview';
translations.en.generatePDF = 'Generate PDF';
translations.en.close = 'Close';
translations.en.confirm = 'Confirm';
translations.en.delete = 'Delete';
translations.en.edit = 'Edit';
translations.en.save = 'Save';
translations.en.back = 'Back';
translations.en.next = 'Next';
translations.en.finish = 'Finish';
translations.en.error = 'Error';
translations.en.success = 'Success';
translations.en.warning = 'Warning';
translations.en.info = 'Info';
translations.en.downloadLimit = 'Web version allows 1 download per day.';
translations.en.downloadApp = 'Download desktop app for unlimited use.';
translations.en.openDownloadPage = 'Open download page?';
translations.en.cooldownMessage = 'Download cooldown: Please retry in {seconds} seconds';
translations.en.paymentCancelled = 'Payment cancelled';
translations.en.paymentSuccess = 'Payment completed';
translations.en.syncSuccess = 'Sync completed';
translations.en.deleteConfirm = 'Are you sure you want to delete?';
translations.en.deleteAllDataConfirm = 'Delete all data? This action cannot be undone.';

// Korean
translations.ko.entryManagement = '입장 관리';
translations.ko.entryStatus = '입장 상태';
translations.ko.designPDF = '디자인 PDF';
translations.ko.csvImport = 'CSV 가져오기';
translations.ko.refreshSync = '최신 업데이트 (웹 동기화)';
translations.ko.purchaseSlots = '슬롯 구매';
translations.ko.remainingSlots = '남은 슬롯';
translations.ko.usedSlots = '사용됨';
translations.ko.totalSlots = '총 슬롯';
translations.ko.qrCodeList = 'QR 코드 목록';
translations.ko.entryTime = '입장 시간';
translations.ko.entryDevice = '입장 장치';
translations.ko.entered = '입장함';
translations.ko.notEntered = '미입장';
translations.ko.all = '전체';
translations.ko.filter = '필터';
translations.ko.search = '검색';
translations.ko.freeText = '자유 입력';
translations.ko.scanQR = 'QR 스캔';
translations.ko.manualInput = '수동 입력';
translations.ko.cameraMode = '카메라 모드';
translations.ko.selectTemplate = '템플릿 선택';
translations.ko.modern = '모던';
translations.ko.classic = '클래식';
translations.ko.pop = '팝';
translations.ko.eventInfo = '이벤트 정보';
translations.ko.eventDate = '이벤트 날짜';
translations.ko.venue = '장소';
translations.ko.seatInfo = '좌석 정보';
translations.ko.layout = '레이아웃';
translations.ko.a4Layout = 'A4 레이아웃';
translations.ko.individual = '개별';
translations.ko.mobileLayout = '모바일 세로 레이아웃';
translations.ko.preview = '미리보기';
translations.ko.generatePDF = 'PDF 생성';
translations.ko.close = '닫기';
translations.ko.confirm = '확인';
translations.ko.delete = '삭제';
translations.ko.edit = '편집';
translations.ko.save = '저장';
translations.ko.back = '뒤로';
translations.ko.next = '다음';
translations.ko.finish = '완료';
translations.ko.error = '오류';
translations.ko.success = '성공';
translations.ko.warning = '경고';
translations.ko.info = '정보';
translations.ko.downloadLimit = '웹 버전은 하루에 1회 다운로드 가능합니다.';
translations.ko.downloadApp = '무제한 사용을 위해 데스크톱 앱을 다운로드하세요.';
translations.ko.openDownloadPage = '다운로드 페이지를 여시겠습니까?';
translations.ko.cooldownMessage = '다운로드 대기: {seconds}초 후 다시 시도하세요';
translations.ko.paymentCancelled = '결제가 취소되었습니다';
translations.ko.paymentSuccess = '결제가 완료되었습니다';
translations.ko.syncSuccess = '동기화가 완료되었습니다';
translations.ko.deleteConfirm = '정말 삭제하시겠습니까?';
translations.ko.deleteAllDataConfirm = '모든 데이터를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.';

// Chinese
translations.zh.entryManagement = '入场管理';
translations.zh.entryStatus = '入场状态';
translations.zh.designPDF = '设计PDF';
translations.zh.csvImport = 'CSV导入';
translations.zh.refreshSync = '刷新（网页同步）';
translations.zh.purchaseSlots = '购买槽位';
translations.zh.remainingSlots = '剩余槽位';
translations.zh.usedSlots = '已使用';
translations.zh.totalSlots = '总槽位';
translations.zh.qrCodeList = '二维码列表';
translations.zh.entryTime = '入场时间';
translations.zh.entryDevice = '入场设备';
translations.zh.entered = '已入场';
translations.zh.notEntered = '未入场';
translations.zh.all = '全部';
translations.zh.filter = '筛选';
translations.zh.search = '搜索';
translations.zh.freeText = '自由输入';
translations.zh.scanQR = '扫描二维码';
translations.zh.manualInput = '手动输入';
translations.zh.cameraMode = '相机模式';
translations.zh.selectTemplate = '选择模板';
translations.zh.modern = '现代';
translations.zh.classic = '经典';
translations.zh.pop = '流行';
translations.zh.eventInfo = '活动信息';
translations.zh.eventDate = '活动日期';
translations.zh.venue = '场地';
translations.zh.seatInfo = '座位信息';
translations.zh.layout = '布局';
translations.zh.a4Layout = 'A4布局';
translations.zh.individual = '单独';
translations.zh.mobileLayout = '手机竖版布局';
translations.zh.preview = '预览';
translations.zh.generatePDF = '生成PDF';
translations.zh.close = '关闭';
translations.zh.confirm = '确认';
translations.zh.delete = '删除';
translations.zh.edit = '编辑';
translations.zh.save = '保存';
translations.zh.back = '返回';
translations.zh.next = '下一步';
translations.zh.finish = '完成';
translations.zh.error = '错误';
translations.zh.success = '成功';
translations.zh.warning = '警告';
translations.zh.info = '信息';
translations.zh.downloadLimit = '网页版每天只能下载1次。';
translations.zh.downloadApp = '下载桌面应用以无限制使用。';
translations.zh.openDownloadPage = '打开下载页面？';
translations.zh.cooldownMessage = '下载冷却：请在{seconds}秒后重试';
translations.zh.paymentCancelled = '支付已取消';
translations.zh.paymentSuccess = '支付完成';
translations.zh.syncSuccess = '同步完成';
translations.zh.deleteConfirm = '确定要删除吗？';
translations.zh.deleteAllDataConfirm = '删除所有数据？此操作无法撤销。';


// Additional UI translations
translations.ja.site = 'サイト';
translations.ja.home = 'ホーム';
translations.ja.help = 'ヘルプ';
translations.ja.ticketList = 'チケット一覧';
translations.ja.qrTotal = 'QR合計';
translations.ja.qrCount = 'QR数';
translations.ja.expiryDate = '有効期限';
translations.ja.createNewTicket = '新規チケット作成';
translations.ja.ticketDetails = 'チケット詳細';
translations.ja.issued = '発行済み(チェック済み/発行数)';
translations.ja.qrOperations = 'QR操作';
translations.ja.createQR = 'QR作成';
translations.ja.readQR = 'QR読み取り';
translations.ja.additionalGeneration = '追加生成';
translations.ja.generationComplete = '生成完了';
translations.ja.qrCodes = '個のQRコード';
translations.ja.csvDownloadDesc = 'QRコード一覧をCSV形式で出力（Excel等で開く）';
translations.ja.imageDownloadDesc = '各QRコードをPNG画像ファイルで取得（複数ファイル）';
translations.ja.pdfPrintDesc = 'A4用紙にレイアウト済みのPDFを生成（シール印刷対応）';
translations.ja.designPdfDesc = 'チケット情報とQRコードを含むデザイン済みPDFを生成';
translations.ja.processing = '処理中...';
translations.ja.qrScanEntry = 'QR読み取りで入場処理';
translations.ja.confirmOnScan = 'QR読み込み時確認をする';
translations.ja.manualEntryCode = '入場コード手入力';
translations.ja.pasteQRString = 'QR文字列を貼り付け';
translations.ja.manualEntry = '手入力で入場処理';
translations.ja.qrScanner = 'QRスキャナー（入場処理）';
translations.ja.csvImportTitle = 'CSVからフリー入力データをインポート';
translations.ja.qrImageDownloadTitle = 'QR画像をPNG形式でダウンロード';
translations.ja.pdfDownloadTitle = 'QRコードをPDF形式でダウンロード（シール印刷対応、3つのレイアウト選択可）';
translations.ja.designPdfTitle = 'デザイン付きチケットPDFを生成（3つのテンプレートから選択）';
translations.ja.csvDownloadTitle = 'QRコード一覧をCSV形式でダウンロード（フリー入力欄付き）';
translations.ja.externalDevicePermission = '外部デバイス許可';
translations.ja.externalScannerButton = '外部スキャナー';
translations.ja.externalScannerModeTitle = '外部スキャナーモード（認証不要でチケットをスキャン）';
translations.ja.selectTargetTicket = '設定対象のチケット';
translations.ja.selectTicketPlaceholder = 'チケットを選択';
translations.ja.allowExternalScan = 'このチケットのQR読み取りを外部デバイスに許可する(🔓 外部スキャナーでスキャンできます)';
translations.ja.externalAccessEnabled = '外部デバイス許可を有効にしました';
translations.ja.externalAccessDisabled = '外部デバイス許可を無効にしました';
translations.ja.purchaseConfirmTitle = 'QR枠購入 確認';
translations.ja.purchaseConfirmBody = '1件あたり 10枠（¥100 / 30日有効）です。購入件数を選んでください。';
translations.ja.purchaseQuantity = '購入件数';
translations.ja.totalAmount = '合計金額';
translations.ja.confirmPurchase = '確認して購入';
translations.ja.purchaseHistory = '購入履歴';
translations.ja.deleteAllDataConfirmFirst = 'このアカウントの全データを削除します。購入したQR枠を含むすべてのデータが消えます。続行しますか？';
translations.ja.deleteAllDataConfirmSecond = '最終確認: この操作は取り消せません。本当に全データを削除しますか？';
translations.ja.deleteAllDataSuccess = 'データを全削除しました（チケット{tickets}件 / 購入履歴{subscriptions}件 / プロフィール{profiles}件 / IDリンク{links}件）';
translations.ja.deleteAllDataPartialFail = 'データを全削除しました（チケット{tickets}件 / 購入履歴{subscriptions}件 / プロフィール{profiles}件 / IDリンク{links}件） ※一部のFirestore削除に失敗: {failed}';
translations.ja.deleteTicketConfirm = '本当にこのチケットを削除しますか？';
translations.ja.scanConfirm = '読み込みできました\nID: {id}\n\n入場処理を実行しますか？';
translations.ja.scanCancelled = 'キャンセルしました（ID: {id}）';
translations.ja.scanSuccess = '読み込み完了 / 入場OK（ID: {id}）';
translations.ja.scanSuccessShort = '読み込み完了（ID: {id}）';
translations.ja.alreadyEnteredAlert = '⚠️ このQRは既に入場済みです\nID: {id}\n入場時刻: {time}';
translations.ja.alreadyEnteredMessage = 'このQRは既に入場済みです（ID: {id}）';
translations.ja.entryProcessFailed = '入場処理に失敗しました';
translations.ja.cameraNotAvailable = 'この環境ではカメラAPIが利用できません';
translations.ja.cameraStartFailed = 'カメラ起動に失敗しました';
translations.ja.qrNotFound = '該当するQRが見つかりません';
translations.ja.ticketSystemTitle = 'チケット管理システム';
translations.ja.purchaseQRSlots = 'QR枠購入（30日有効）';

translations.en.site = 'Site';
translations.en.home = 'Home';
translations.en.help = 'Help';
translations.en.ticketList = 'Ticket List';
translations.en.qrTotal = 'QR Total';
translations.en.qrCount = 'QR Count';
translations.en.expiryDate = 'Expiry Date';
translations.en.createNewTicket = 'Create New Ticket';
translations.en.ticketDetails = 'Ticket Details';
translations.en.issued = 'Issued (Checked/Total)';
translations.en.qrOperations = 'QR Operations';
translations.en.createQR = 'Create QR';
translations.en.readQR = 'Read QR';
translations.en.additionalGeneration = 'Additional Generation';
translations.en.generationComplete = 'Generation Complete';
translations.en.qrCodes = ' QR codes';
translations.en.csvDownloadDesc = 'Export QR code list in CSV format (open with Excel, etc.)';
translations.en.imageDownloadDesc = 'Get each QR code as PNG image file (multiple files)';
translations.en.pdfPrintDesc = 'Generate PDF with A4 layout (sticker printing support)';
translations.en.designPdfDesc = 'Generate designed PDF with ticket info and QR codes';
translations.en.processing = 'Processing...';
translations.en.qrScanEntry = 'Scan QR for Entry';
translations.en.confirmOnScan = 'Confirm on QR scan';
translations.en.manualEntryCode = 'Manual Entry Code';
translations.en.pasteQRString = 'Paste QR string';
translations.en.manualEntry = 'Manual Entry Process';
translations.en.qrScanner = 'QR Scanner (Entry Process)';
translations.en.csvImportTitle = 'Import free text data from CSV';
translations.en.qrImageDownloadTitle = 'Download QR images in PNG format';
translations.en.pdfDownloadTitle = 'Download QR codes in PDF format (sticker printing support, 3 layouts)';
translations.en.designPdfTitle = 'Generate designed ticket PDF (choose from 3 templates)';
translations.en.csvDownloadTitle = 'Download QR code list in CSV format (with free text field)';
translations.en.externalDevicePermission = 'Device Access';
translations.en.externalScannerButton = 'External Scanner';
translations.en.externalScannerModeTitle = 'External Scanner Mode (scan tickets without authentication)';
translations.en.selectTargetTicket = 'Select Target Ticket';
translations.en.selectTicketPlaceholder = 'Select a ticket';
translations.en.allowExternalScan = 'Allow external devices to scan this ticket';
translations.en.externalAccessEnabled = 'External device access enabled';
translations.en.externalAccessDisabled = 'External device access disabled';
translations.en.purchaseConfirmTitle = 'QR Slot Purchase Confirmation';
translations.en.purchaseConfirmBody = '10 slots per item (¥100 / valid for 30 days). Choose purchase quantity.';
translations.en.purchaseQuantity = 'Purchase Quantity';
translations.en.totalAmount = 'Total Amount';
translations.en.confirmPurchase = 'Confirm and Purchase';
translations.en.purchaseHistory = 'Purchase History';
translations.en.deleteAllDataConfirmFirst = 'Delete all data for this account. All data including purchased QR slots will be removed. Continue?';
translations.en.deleteAllDataConfirmSecond = 'Final confirmation: This action cannot be undone. Really delete all data?';
translations.en.deleteAllDataSuccess = 'Deleted all data (Tickets: {tickets} / Purchases: {subscriptions} / Profiles: {profiles} / ID Links: {links})';
translations.en.deleteAllDataPartialFail = 'Deleted all data (Tickets: {tickets} / Purchases: {subscriptions} / Profiles: {profiles} / ID Links: {links}) ※Some Firestore deletions failed: {failed}';
translations.en.deleteTicketConfirm = 'Really delete this ticket?';
translations.en.scanConfirm = 'Scan successful\nID: {id}\n\nProcess entry?';
translations.en.scanCancelled = 'Cancelled (ID: {id})';
translations.en.scanSuccess = 'Scan complete / Entry OK (ID: {id})';
translations.en.scanSuccessShort = 'Scan complete (ID: {id})';
translations.en.alreadyEnteredAlert = '⚠️ This QR code has already been used\nID: {id}\nEntry time: {time}';
translations.en.alreadyEnteredMessage = 'This QR code has already been used (ID: {id})';
translations.en.entryProcessFailed = 'Entry process failed';
translations.en.cameraNotAvailable = 'Camera API not available in this environment';
translations.en.cameraStartFailed = 'Failed to start camera';
translations.en.qrNotFound = 'QR code not found';
translations.en.ticketSystemTitle = 'Ticket Management System';
translations.en.purchaseQRSlots = 'Purchase QR Slots (30 days)';

translations.ko.site = '사이트';
translations.ko.home = '홈';
translations.ko.help = '도움말';
translations.ko.ticketList = '티켓 목록';
translations.ko.qrTotal = 'QR 합계';
translations.ko.qrCount = 'QR 수';
translations.ko.expiryDate = '만료일';
translations.ko.createNewTicket = '새 티켓 만들기';
translations.ko.ticketDetails = '티켓 상세';
translations.ko.issued = '발행됨 (확인됨/총)';
translations.ko.qrOperations = 'QR 작업';
translations.ko.createQR = 'QR 생성';
translations.ko.readQR = 'QR 읽기';
translations.ko.additionalGeneration = '추가 생성';
translations.ko.generationComplete = '생성 완료';
translations.ko.qrCodes = '개의 QR 코드';
translations.ko.csvDownloadDesc = 'QR 코드 목록을 CSV 형식으로 내보내기 (Excel 등으로 열기)';
translations.ko.imageDownloadDesc = '각 QR 코드를 PNG 이미지 파일로 가져오기 (여러 파일)';
translations.ko.pdfPrintDesc = 'A4 레이아웃으로 PDF 생성 (스티커 인쇄 지원)';
translations.ko.designPdfDesc = '티켓 정보와 QR 코드가 포함된 디자인 PDF 생성';
translations.ko.processing = '처리 중...';
translations.ko.qrScanEntry = '입장을 위한 QR 스캔';
translations.ko.confirmOnScan = 'QR 스캔 시 확인';
translations.ko.manualEntryCode = '수동 입장 코드';
translations.ko.pasteQRString = 'QR 문자열 붙여넣기';
translations.ko.manualEntry = '수동 입장 처리';
translations.ko.qrScanner = 'QR 스캐너 (입장 처리)';
translations.ko.csvImportTitle = 'CSV에서 자유 텍스트 데이터 가져오기';
translations.ko.qrImageDownloadTitle = 'PNG 형식으로 QR 이미지 다운로드';
translations.ko.pdfDownloadTitle = 'PDF 형식으로 QR 코드 다운로드 (스티커 인쇄 지원, 3가지 레이아웃)';
translations.ko.designPdfTitle = '디자인된 티켓 PDF 생성 (3가지 템플릿 중 선택)';
translations.ko.csvDownloadTitle = 'CSV 형식으로 QR 코드 목록 다운로드 (자유 텍스트 필드 포함)';
translations.ko.externalDevicePermission = '외부 장치 권한';
translations.ko.externalScannerButton = '외부 스캐너';
translations.ko.externalScannerModeTitle = '외부 스캐너 모드 (인증 없이 티켓 스캔)';
translations.ko.selectTargetTicket = '대상 티켓 선택';
translations.ko.selectTicketPlaceholder = '티켓 선택';
translations.ko.allowExternalScan = '외부 장치에서 이 티켓을 스캔할 수 있도록 허용';
translations.ko.externalAccessEnabled = '외부 장치 액세스가 활성화되었습니다';
translations.ko.externalAccessDisabled = '외부 장치 액세스가 비활성화되었습니다';
translations.ko.purchaseConfirmTitle = 'QR 슬롯 구매 확인';
translations.ko.purchaseConfirmBody = '항목당 10개 슬롯 (¥100 / 30일 유효). 구매 수량을 선택하세요.';
translations.ko.purchaseQuantity = '구매 수량';
translations.ko.totalAmount = '총 금액';
translations.ko.confirmPurchase = '확인 및 구매';
translations.ko.purchaseHistory = '구매 내역';
translations.ko.deleteAllDataConfirmFirst = '이 계정의 모든 데이터를 삭제합니다. 구매한 QR 슬롯을 포함한 모든 데이터가 제거됩니다. 계속하시겠습니까?';
translations.ko.deleteAllDataConfirmSecond = '최종 확인: 이 작업은 취소할 수 없습니다. 정말 모든 데이터를 삭제하시겠습니까?';
translations.ko.deleteAllDataSuccess = '모든 데이터 삭제됨 (티켓: {tickets} / 구매: {subscriptions} / 프로필: {profiles} / ID 링크: {links})';
translations.ko.deleteAllDataPartialFail = '모든 데이터 삭제됨 (티켓: {tickets} / 구매: {subscriptions} / 프로필: {profiles} / ID 링크: {links}) ※일부 Firestore 삭제 실패: {failed}';
translations.ko.deleteTicketConfirm = '정말 이 티켓을 삭제하시겠습니까?';
translations.ko.scanConfirm = '스캔 성공\nID: {id}\n\n입장을 처리하시겠습니까?';
translations.ko.scanCancelled = '취소됨 (ID: {id})';
translations.ko.scanSuccess = '스캔 완료 / 입장 OK (ID: {id})';
translations.ko.scanSuccessShort = '스캔 완료 (ID: {id})';
translations.ko.alreadyEnteredAlert = '⚠️ 이 QR 코드는 이미 사용되었습니다\nID: {id}\n입장 시간: {time}';
translations.ko.alreadyEnteredMessage = '이 QR 코드는 이미 사용되었습니다 (ID: {id})';
translations.ko.entryProcessFailed = '입장 처리 실패';
translations.ko.cameraNotAvailable = '이 환경에서는 카메라 API를 사용할 수 없습니다';
translations.ko.cameraStartFailed = '카메라 시작 실패';
translations.ko.qrNotFound = 'QR 코드를 찾을 수 없습니다';
translations.ko.ticketSystemTitle = '티켓 관리 시스템';
translations.ko.purchaseQRSlots = 'QR 슬롯 구매 (30일)';

translations.zh.site = '网站';
translations.zh.home = '主页';
translations.zh.help = '帮助';
translations.zh.ticketList = '票券列表';
translations.zh.qrTotal = 'QR 总计';
translations.zh.qrCount = 'QR 数量';
translations.zh.expiryDate = '到期日期';
translations.zh.createNewTicket = '创建新票券';
translations.zh.ticketDetails = '票券详情';
translations.zh.issued = '已发行（已检查/总数）';
translations.zh.qrOperations = 'QR 操作';
translations.zh.createQR = '创建 QR';
translations.zh.readQR = '读取 QR';
translations.zh.additionalGeneration = '追加生成';
translations.zh.generationComplete = '生成完成';
translations.zh.qrCodes = ' 个二维码';
translations.zh.csvDownloadDesc = '以CSV格式导出二维码列表（用Excel等打开）';
translations.zh.imageDownloadDesc = '将每个二维码获取为PNG图像文件（多个文件）';
translations.zh.pdfPrintDesc = '生成A4布局的PDF（支持贴纸打印）';
translations.zh.designPdfDesc = '生成包含票券信息和二维码的设计PDF';
translations.zh.processing = '处理中...';
translations.zh.qrScanEntry = '扫描二维码入场';
translations.zh.confirmOnScan = '扫描二维码时确认';
translations.zh.manualEntryCode = '手动入场代码';
translations.zh.pasteQRString = '粘贴二维码字符串';
translations.zh.manualEntry = '手动入场处理';
translations.zh.qrScanner = '二维码扫描仪（入场处理）';
translations.zh.csvImportTitle = '从CSV导入自由文本数据';
translations.zh.qrImageDownloadTitle = '以PNG格式下载二维码图片';
translations.zh.pdfDownloadTitle = '以PDF格式下载二维码（支持贴纸打印，3种布局）';
translations.zh.designPdfTitle = '生成设计票券PDF（从3个模板中选择）';
translations.zh.csvDownloadTitle = '以CSV格式下载二维码列表（含自由文本字段）';
translations.zh.externalDevicePermission = '外部设备权限';
translations.zh.externalScannerButton = '外部扫描仪';
translations.zh.externalScannerModeTitle = '外部扫描仪模式（无需认证扫描票券）';
translations.zh.selectTargetTicket = '选择目标票券';
translations.zh.selectTicketPlaceholder = '选择票券';
translations.zh.allowExternalScan = '允许外部设备扫描此票券';
translations.zh.externalAccessEnabled = '已启用外部设备访问';
translations.zh.externalAccessDisabled = '已禁用外部设备访问';
translations.zh.purchaseConfirmTitle = 'QR 槽位购买确认';
translations.zh.purchaseConfirmBody = '每项10个槽位（¥100 / 30天有效）。选择购买数量。';
translations.zh.purchaseQuantity = '购买数量';
translations.zh.totalAmount = '总金额';
translations.zh.confirmPurchase = '确认并购买';
translations.zh.purchaseHistory = '购买历史';
translations.zh.deleteAllDataConfirmFirst = '删除此账户的所有数据。包括已购买的QR槽位在内的所有数据将被删除。继续？';
translations.zh.deleteAllDataConfirmSecond = '最终确认：此操作无法撤销。真的要删除所有数据吗？';
translations.zh.deleteAllDataSuccess = '已删除所有数据（票券：{tickets} / 购买：{subscriptions} / 配置文件：{profiles} / ID链接：{links}）';
translations.zh.deleteAllDataPartialFail = '已删除所有数据（票券：{tickets} / 购买：{subscriptions} / 配置文件：{profiles} / ID链接：{links}） ※部分Firestore删除失败：{failed}';
translations.zh.deleteTicketConfirm = '真的要删除此票券吗？';
translations.zh.scanConfirm = '扫描成功\nID：{id}\n\n处理入场？';
translations.zh.scanCancelled = '已取消（ID：{id}）';
translations.zh.scanSuccess = '扫描完成 / 入场OK（ID：{id}）';
translations.zh.scanSuccessShort = '扫描完成（ID：{id}）';
translations.zh.alreadyEnteredAlert = '⚠️ 此二维码已被使用\nID：{id}\n入场时间：{time}';
translations.zh.alreadyEnteredMessage = '此二维码已被使用（ID：{id}）';
translations.zh.entryProcessFailed = '入场处理失败';
translations.zh.cameraNotAvailable = '此环境中无法使用相机API';
translations.zh.cameraStartFailed = '启动相机失败';
translations.zh.qrNotFound = '未找到二维码';
translations.zh.ticketSystemTitle = '票券管理系统';
translations.ja.purchaseError = '購入処理エラー: {error}';
translations.ja.purchaseSuccess = '{quantity}件 / {slots}枠の購入を反映しました（開発モード）';
translations.ja.noValidQRCodes = '有効なQRコードがありません';
translations.ja.purchaseButton = '購入';
translations.ja.entryStatusTitle = '入場状況';
translations.ja.ticketSelection = 'チケット選択';
translations.ja.selectTicketPlease = '-- チケットを選択してください --';
translations.ja.selectTicketFromDropdown = '上のプルダウンからチケットを選択してください';
translations.ja.noQRCodesGenerated = 'このチケットにはQRコードが生成されていません';
translations.ja.generateQRCodesFirst = 'チケットタブでQRコードを生成してください';
translations.ja.goToTicketsTab = 'チケットタブへ移動';
translations.ja.totalIssued = '総発行数';
translations.ja.sheets = '枚';
translations.ja.entryRate = '入場率';
translations.ja.csvExport = 'CSV出力';
translations.ja.csvExportTitle = '入場状況をCSV形式でダウンロード';
translations.ja.csvExported = 'CSVファイルをダウンロードしました';
translations.ja.csvExportFailed = 'CSV出力に失敗しました: {error}';
translations.ja.qrCodeSearch = 'QRコード検索';
translations.ja.searchPlaceholder = '例: ABC123 (部分一致) または ABC% (前方一致)';
translations.ja.searchTitle = 'デフォルトは部分一致。% で前方一致・後方一致を指定可能';
translations.ja.clearSearch = '検索をクリア';
translations.ja.freeTextSearch = 'フリー入力検索';
translations.ja.freeTextSearchPlaceholder = 'フリー入力で検索';
translations.ja.statusFilter = '状態フィルター';
translations.ja.allStatus = 'すべて';
translations.ja.enteredOnly = '入場済みのみ';
translations.ja.unusedOnly = '未入場のみ';
translations.ja.sortBy = '並び替え';
translations.ja.sortTimeDesc = '入場日時（新しい順）';
translations.ja.sortTimeAsc = '入場日時（古い順）';
translations.ja.sortQrAsc = 'QRコード（昇順）';
translations.ja.sortQrDesc = 'QRコード（降順）';
translations.ja.tableHeaderNo = 'No.';
translations.ja.tableHeaderQRCode = 'QRコード';
translations.ja.tableHeaderStatus = '状態';
translations.ja.tableHeaderEntryTime = '入場日時';
translations.ja.tableHeaderDevice = 'デバイス';
translations.ja.tableHeaderFreeText = 'フリー入力';
translations.ja.qrCodesLoaded = '{count}件のQRコードを読み込みました';
translations.ja.statusEntered = '✓ 入場済み';
translations.ja.statusUnused = '○ 未入場';
translations.ja.tableHeaderComment = 'コメント';
translations.ja.commentPlaceholder = 'コメントを入力…';
translations.ja.tableHeaderAction = '操作';
translations.ja.manualSetEntered = '入場済みにする';
translations.ja.manualUnsetEntered = '入場解除';
translations.ja.manualSetEnteredConfirm = 'このQRコードを手動で入場済みにしますか？';
translations.ja.manualUnsetEnteredConfirm = 'このQRコードの入場を解除しますか？';

translations.en.purchaseError = 'Purchase error: {error}';
translations.en.purchaseSuccess = 'Applied purchase of {quantity} items / {slots} slots (dev mode)';
translations.en.noValidQRCodes = 'No valid QR codes';
translations.en.purchaseButton = 'Purchase';
translations.en.entryStatusTitle = 'Entry Status';
translations.en.ticketSelection = 'Ticket Selection';
translations.en.selectTicketPlease = '-- Please select a ticket --';
translations.en.selectTicketFromDropdown = 'Please select a ticket from the dropdown above';
translations.en.noQRCodesGenerated = 'No QR codes generated for this ticket';
translations.en.generateQRCodesFirst = 'Please generate QR codes in the Tickets tab';
translations.en.goToTicketsTab = 'Go to Tickets Tab';
translations.en.totalIssued = 'Total Issued';
translations.en.sheets = ' tickets';
translations.en.entryRate = 'Entry Rate';
translations.en.csvExport = 'Export CSV';
translations.en.csvExportTitle = 'Download entry status in CSV format';
translations.en.csvExported = 'CSV file downloaded';
translations.en.csvExportFailed = 'CSV export failed: {error}';
translations.en.qrCodeSearch = 'QR Code Search';
translations.en.searchPlaceholder = 'e.g., ABC123 (partial match) or ABC% (prefix match)';
translations.en.searchTitle = 'Default is partial match. Use % for prefix/suffix match';
translations.en.clearSearch = 'Clear search';
translations.en.freeTextSearch = 'Free Text Search';
translations.en.freeTextSearchPlaceholder = 'Search by free text';
translations.en.statusFilter = 'Status Filter';
translations.en.allStatus = 'All';
translations.en.enteredOnly = 'Entered only';
translations.en.unusedOnly = 'Not entered only';
translations.en.sortBy = 'Sort by';
translations.en.sortTimeDesc = 'Entry time (newest first)';
translations.en.sortTimeAsc = 'Entry time (oldest first)';
translations.en.sortQrAsc = 'QR code (ascending)';
translations.en.sortQrDesc = 'QR code (descending)';
translations.en.tableHeaderNo = 'No.';
translations.en.tableHeaderQRCode = 'QR Code';
translations.en.tableHeaderStatus = 'Status';
translations.en.tableHeaderEntryTime = 'Entry Time';
translations.en.tableHeaderDevice = 'Device';
translations.en.tableHeaderFreeText = 'Free Text';
translations.en.qrCodesLoaded = 'Loaded {count} QR codes';
translations.en.statusEntered = '✓ Entered';
translations.en.statusUnused = '○ Not Entered';
translations.en.tableHeaderComment = 'Comment';
translations.en.commentPlaceholder = 'Add a comment…';
translations.en.tableHeaderAction = 'Action';
translations.en.manualSetEntered = 'Mark as Entered';
translations.en.manualUnsetEntered = 'Revert Entry';
translations.en.manualSetEnteredConfirm = 'Manually mark this QR code as entered?';
translations.en.manualUnsetEnteredConfirm = 'Revert the entry for this QR code?';

translations.ko.purchaseError = '구매 처리 오류: {error}';
translations.ko.purchaseSuccess = '{quantity}개 / {slots}슬롯 구매가 반영되었습니다 (개발 모드)';
translations.ko.noValidQRCodes = '유효한 QR 코드가 없습니다';
translations.ko.purchaseButton = '구매';
translations.ko.entryStatusTitle = '입장 상태';
translations.ko.ticketSelection = '티켓 선택';
translations.ko.selectTicketPlease = '-- 티켓을 선택하세요 --';
translations.ko.selectTicketFromDropdown = '위 드롭다운에서 티켓을 선택하세요';
translations.ko.noQRCodesGenerated = '이 티켓에 생성된 QR 코드가 없습니다';
translations.ko.generateQRCodesFirst = '티켓 탭에서 QR 코드를 생성하세요';
translations.ko.goToTicketsTab = '티켓 탭으로 이동';
translations.ko.totalIssued = '총 발행 수';
translations.ko.sheets = '장';
translations.ko.entryRate = '입장률';
translations.ko.csvExport = 'CSV 내보내기';
translations.ko.csvExportTitle = 'CSV 형식으로 입장 상태 다운로드';
translations.ko.csvExported = 'CSV 파일이 다운로드되었습니다';
translations.ko.csvExportFailed = 'CSV 내보내기 실패: {error}';
translations.ko.qrCodeSearch = 'QR 코드 검색';
translations.ko.searchPlaceholder = '예: ABC123 (부분 일치) 또는 ABC% (접두사 일치)';
translations.ko.searchTitle = '기본값은 부분 일치입니다. %를 사용하여 접두사/접미사 일치';
translations.ko.clearSearch = '검색 지우기';
translations.ko.freeTextSearch = '자유 텍스트 검색';
translations.ko.freeTextSearchPlaceholder = '자유 텍스트로 검색';
translations.ko.statusFilter = '상태 필터';
translations.ko.allStatus = '전체';
translations.ko.enteredOnly = '입장함만';
translations.ko.unusedOnly = '미입장만';
translations.ko.sortBy = '정렬';
translations.ko.sortTimeDesc = '입장 시간 (최신순)';
translations.ko.sortTimeAsc = '입장 시간 (오래된순)';
translations.ko.sortQrAsc = 'QR 코드 (오름차순)';
translations.ko.sortQrDesc = 'QR 코드 (내림차순)';
translations.ko.tableHeaderNo = '번호';
translations.ko.tableHeaderQRCode = 'QR 코드';
translations.ko.tableHeaderStatus = '상태';
translations.ko.tableHeaderEntryTime = '입장 시간';
translations.ko.tableHeaderDevice = '장치';
translations.ko.tableHeaderFreeText = '자유 텍스트';
translations.ko.qrCodesLoaded = '{count}개의 QR 코드를 로드했습니다';
translations.ko.statusEntered = '✓ 입장 완료';
translations.ko.statusUnused = '○ 미입장';
translations.ko.tableHeaderComment = '코멘트';
translations.ko.commentPlaceholder = '코멘트 입력…';
translations.ko.tableHeaderAction = '작업';
translations.ko.manualSetEntered = '입장 처리';
translations.ko.manualUnsetEntered = '입장 취소';
translations.ko.manualSetEnteredConfirm = '이 QR 코드를 수동으로 입장 처리하시겠습니까?';
translations.ko.manualUnsetEnteredConfirm = '이 QR 코드의 입장을 취소하시겠습니까?';

translations.zh.purchaseError = '购买处理错误：{error}';
translations.zh.purchaseSuccess = '已应用购买 {quantity} 项 / {slots} 槽位（开发模式）';
translations.zh.noValidQRCodes = '没有有效的二维码';
translations.zh.purchaseButton = '购买';
translations.zh.entryStatusTitle = '入场状态';
translations.zh.ticketSelection = '票券选择';
translations.zh.selectTicketPlease = '-- 请选择票券 --';
translations.zh.selectTicketFromDropdown = '请从上方下拉菜单中选择票券';
translations.zh.noQRCodesGenerated = '此票券没有生成的二维码';
translations.zh.generateQRCodesFirst = '请在票券标签中生成二维码';
translations.zh.goToTicketsTab = '前往票券标签';
translations.zh.totalIssued = '总发行数';
translations.zh.sheets = '张';
translations.zh.entryRate = '入场率';
translations.zh.csvExport = '导出CSV';
translations.zh.csvExportTitle = '以CSV格式下载入场状态';
translations.zh.csvExported = 'CSV文件已下载';
translations.zh.csvExportFailed = 'CSV导出失败：{error}';
translations.zh.qrCodeSearch = '二维码搜索';
translations.zh.searchPlaceholder = '例如：ABC123（部分匹配）或 ABC%（前缀匹配）';
translations.zh.searchTitle = '默认为部分匹配。使用 % 进行前缀/后缀匹配';
translations.zh.clearSearch = '清除搜索';
translations.zh.freeTextSearch = '自由文本搜索';
translations.zh.freeTextSearchPlaceholder = '按自由文本搜索';
translations.zh.statusFilter = '状态筛选';
translations.zh.allStatus = '全部';
translations.zh.enteredOnly = '仅已入场';
translations.zh.unusedOnly = '仅未入场';
translations.zh.sortBy = '排序';
translations.zh.sortTimeDesc = '入场时间（最新）';
translations.zh.sortTimeAsc = '入场时间（最旧）';
translations.zh.sortQrAsc = 'QR码（升序）';
translations.zh.sortQrDesc = 'QR码（降序）';
translations.zh.tableHeaderNo = '编号';
translations.zh.tableHeaderQRCode = 'QR码';
translations.zh.tableHeaderStatus = '状态';
translations.zh.tableHeaderEntryTime = '入场时间';
translations.zh.tableHeaderDevice = '设备';
translations.zh.tableHeaderFreeText = '自由文本';
translations.zh.qrCodesLoaded = '已加载 {count} 个二维码';
translations.zh.statusEntered = '✓ 已入场';
translations.zh.statusUnused = '○ 未入场';
translations.zh.tableHeaderComment = '备注';
translations.zh.commentPlaceholder = '输入备注…';
translations.zh.tableHeaderAction = '操作';
translations.zh.manualSetEntered = '标记为已入场';
translations.zh.manualUnsetEntered = '撤销入场';
translations.zh.manualSetEnteredConfirm = '手动将此二维码标记为已入场？';
translations.zh.manualUnsetEnteredConfirm = '撤销此二维码的入场记录？';

translations.ja.logoutTitle = 'ログアウトして初期ユニークIDに戻す';
translations.ja.clearCacheConfirm = 'ローカルキャッシュをクリアしますか？\n次回読み込み時にRTDBから最新データを取得します。';
translations.ja.clearCacheSuccess = '{count}件のキャッシュをクリアしました';
translations.ja.clearLocalCache = 'ローカルキャッシュクリア';
translations.ja.clearCacheTitle = 'QRコードのローカルキャッシュをクリアして、次回読み込み時にRTDBから最新データを取得';
translations.ja.deleteAllDataTitle = 'このアカウントのローカルとFirestoreデータを全削除';
translations.ja.version = 'バージョン';
translations.ja.slot10Pack = '10枠パック';
translations.ja.slot10PackDesc = '¥100で30日間10QRコード追加されます';
translations.ja.noTicketsForPermission = '設定するチケットがありません。先にチケットを作成してください。';

translations.en.qrCodesLoaded = 'Loaded {count} QR codes';
translations.en.logoutTitle = 'Logout and return to initial unique ID';
translations.en.clearCacheConfirm = 'Clear local cache?\nLatest data will be fetched from RTDB on next load.';
translations.en.clearCacheSuccess = 'Cleared {count} cache items';
translations.en.clearLocalCache = 'Clear Local Cache';
translations.en.clearCacheTitle = 'Clear QR code local cache and fetch latest data from RTDB on next load';
translations.en.deleteAllDataTitle = 'Delete all local and Firestore data for this account';
translations.en.version = 'Version';
translations.en.slot10Pack = '10 Slot Pack';
translations.en.slot10PackDesc = '¥100 for 10 QR codes valid for 30 days';
translations.en.noTicketsForPermission = 'No tickets to configure. Please create a ticket first.';

translations.ko.qrCodesLoaded = '{count}개의 QR 코드를 로드했습니다';
translations.ko.logoutTitle = '로그아웃하고 초기 고유 ID로 돌아가기';
translations.ko.clearCacheConfirm = '로컬 캐시를 지우시겠습니까?\n다음 로드 시 RTDB에서 최신 데이터를 가져옵니다.';
translations.ko.clearCacheSuccess = '{count}개의 캐시 항목을 지웠습니다';
translations.ko.clearLocalCache = '로컬 캐시 지우기';
translations.ko.clearCacheTitle = 'QR 코드 로컬 캐시를 지우고 다음 로드 시 RTDB에서 최신 데이터 가져오기';
translations.ko.deleteAllDataTitle = '이 계정의 모든 로컬 및 Firestore 데이터 삭제';
translations.ko.version = '버전';
translations.ko.slot10Pack = '10 슬롯 팩';
translations.ko.slot10PackDesc = '30일 동안 유효한 10개 QR 코드에 ¥100';
translations.ko.noTicketsForPermission = '구성할 티켓이 없습니다. 먼저 티켓을 만드세요.';

translations.zh.qrCodesLoaded = '已加载 {count} 个二维码';
translations.zh.logoutTitle = '登出并返回初始唯一ID';
translations.zh.clearCacheConfirm = '清除本地缓存？\n下次加载时将从RTDB获取最新数据。';
translations.zh.clearCacheSuccess = '已清除 {count} 个缓存项';
translations.zh.clearLocalCache = '清除本地缓存';
translations.zh.clearCacheTitle = '清除二维码本地缓存并在下次加载时从RTDB获取最新数据';
translations.zh.deleteAllDataTitle = '删除此账户的所有本地和Firestore数据';
translations.zh.version = '版本';
translations.zh.slot10Pack = '10槽位包';
translations.zh.slot10PackDesc = '¥100可获得30天有效的10个二维码';
translations.ja.noTicketsForPermission = '設定するチケットがありません。先にチケットを作成してください。';
translations.ja.ticketIdQRCode = 'チケットID QRコード';
translations.ja.generatingQRCode = 'QRコードを生成中...';
translations.ja.allowExternalAccessDesc = 'この設定がONの場合、チケットのIDを携帯に入力したスタッフも QR を読み取り可能になります。';

translations.en.noTicketsForPermission = 'No tickets to configure. Please create a ticket first.';
translations.en.ticketIdQRCode = 'Ticket ID QR Code';
translations.en.generatingQRCode = 'Generating QR code...';
translations.en.allowExternalAccessDesc = 'When this setting is ON, staff who enter the ticket ID on their mobile device can also scan QR codes.';

translations.ko.noTicketsForPermission = '구성할 티켓이 없습니다. 먼저 티켓을 만드세요。';
translations.ko.ticketIdQRCode = '티켓 ID QR 코드';
translations.ko.generatingQRCode = 'QR 코드 생성 중...';
translations.ko.allowExternalAccessDesc = '이 설정이 켜져 있으면 모바일 장치에 티켓 ID를 입력한 직원도 QR 코드를 스캔할 수 있습니다.';

translations.zh.noTicketsForPermission = '没有要配置的票券。请先创建票券。';
translations.zh.ticketIdQRCode = '票券ID二维码';
translations.zh.generatingQRCode = '正在生成二维码...';
translations.ja.allowExternalAccessDesc = 'この設定がONの場合、チケットのIDを携帯に入力したスタッフも QR を読み取り可能になります。';
translations.ja.externalScannerModeTitle = '外部スキャナーモード';
translations.ja.scanQRCode = 'QRコードを読んでください';
translations.ja.scanTicketId = 'チケットIDを読んでください';
translations.ja.selectedTicketQR = '（「{name}」のQRコード）';
translations.ja.cameraError = 'カメラの起動に失敗しました。カメラへのアクセスを許可してください。';
translations.ja.retry = '再試行';
translations.ja.holdQRToCamera = 'QRコードをカメラにかざしてください';
translations.ja.qrScanConfirmToggle = 'QR読み込み時確認をする';
translations.ja.selectedTicketLabel = '【選択チケット】';
translations.ja.clearTicketSelection = 'チケット選択をクリア';
translations.ja.enterQRCode = '「{name}」のQRコードを入力してください';
translations.ja.enterTicketIdPrompt = 'チケットIDを入力してください';
translations.ja.qrCodePlaceholder = 'QRコード（例: W7CFICB6）を入力';
translations.ja.ticketIdPlaceholder = 'チケットID（例: 5iuGByzlP8Yjfw6FWryh）を入力';
translations.ja.execute = '実行';
translations.ja.scanResult = 'スキャン結果';
translations.ja.successStatus = '成功';
translations.ja.failureStatus = '失敗';
translations.ja.scannedValue = '読み取った値';
translations.ja.cameraScan = 'カメラスキャン';
translations.ja.scanHistory = 'スキャン履歴';
translations.ja.items = '件';
translations.ja.clearHistory = '履歴をクリア';
translations.ja.searchPlaceholderHistory = 'QRコード、座席番号、フリー入力で検索...';
translations.ja.noSearchResults = '検索結果がありません';
translations.ja.noScanHistory = 'スキャン履歴がありません';
translations.ja.usageInfo = 'カメラでQRコードをスキャンするか、QRコードまたはチケットIDを手動で入力してください。外部公開に対応したチケットのみ処理されます。';
translations.ja.ticketIdConfirm = 'チケットID 確認';
translations.ja.alreadyScannedWarning = '既に読み込み済みです';
translations.ja.continue = '続行';
translations.ja.initializationFailed = '初期化に失敗しました';
translations.ja.enterQROrTicketId = 'QRコード・チケットIDを入力してください';
translations.ja.ticketNotFound = 'チケットが見つかりません。チケットIDを確認してください。';
translations.ja.ticketInfoFetchFailed = 'チケット情報の取得に失敗しました';
translations.ja.ticketSelected = 'チケット「{name}」を選択しました。QRコードをスキャンしてください。';
translations.ja.qrNotForSelectedTicket = 'このQRは選択中のチケット「{name}」のものではありません';
translations.ja.qrVerificationFailed = 'QRコードの検証に失敗しました';
translations.ja.selectTicketOrScanQR = 'チケットを選択するか、チケットIDを含むQRコードをスキャンしてください';
translations.ja.confirmEntryProcess = '確認: このチケットで入場処理を進めますか？';
translations.ja.enteredToTicket = '{name}に入場しました';
translations.ja.processingError = '処理エラー';
translations.ja.ticketDeleted = '選択中のチケットが削除されました';
translations.ja.newEntry = '新しい入場';
translations.ja.ticketIdScanned = 'チケットIDを読み込みました\n「{name}」が選択されました';

translations.en.allowExternalAccessDesc = 'When this setting is ON, staff who enter the ticket ID on their mobile device can also scan QR codes.';
translations.en.externalScannerModeTitle = 'External Scanner Mode';
translations.en.scanQRCode = 'Scan QR Code';
translations.en.scanTicketId = 'Scan Ticket ID';
translations.en.selectedTicketQR = '(QR code for "{name}")';
translations.en.cameraError = 'Failed to start camera. Please allow camera access.';
translations.en.retry = 'Retry';
translations.en.holdQRToCamera = 'Hold QR code to camera';
translations.en.qrScanConfirmToggle = 'Confirm on QR scan';
translations.en.selectedTicketLabel = '【Selected Ticket】';
translations.en.clearTicketSelection = 'Clear ticket selection';
translations.en.enterQRCode = 'Enter QR code for "{name}"';
translations.en.enterTicketIdPrompt = 'Enter Ticket ID';
translations.en.qrCodePlaceholder = 'Enter QR code (e.g., W7CFICB6)';
translations.en.ticketIdPlaceholder = 'Enter Ticket ID (e.g., 5iuGByzlP8Yjfw6FWryh)';
translations.en.execute = 'Execute';
translations.en.scanResult = 'Scan Result';
translations.en.successStatus = 'Success';
translations.en.failureStatus = 'Failed';
translations.en.scannedValue = 'Scanned value';
translations.en.cameraScan = 'Camera Scan';
translations.en.scanHistory = 'Scan History';
translations.en.items = ' items';
translations.en.clearHistory = 'Clear history';
translations.en.searchPlaceholderHistory = 'Search by QR code, seat number, free text...';
translations.en.noSearchResults = 'No search results';
translations.en.noScanHistory = 'No scan history';
translations.en.usageInfo = 'Scan QR codes with camera or manually enter QR code or Ticket ID. Only tickets with external access enabled will be processed.';
translations.en.ticketIdConfirm = 'Ticket ID Confirmation';
translations.en.alreadyScannedWarning = 'Already scanned';
translations.en.continue = 'Continue';
translations.en.initializationFailed = 'Initialization failed';
translations.en.enterQROrTicketId = 'Please enter QR code or Ticket ID';
translations.en.ticketNotFound = 'Ticket not found. Please check the Ticket ID.';
translations.en.ticketInfoFetchFailed = 'Failed to fetch ticket information';
translations.en.ticketSelected = 'Selected ticket "{name}". Please scan QR code.';
translations.en.qrNotForSelectedTicket = 'This QR code is not for the selected ticket "{name}"';
translations.en.qrVerificationFailed = 'QR code verification failed';
translations.en.selectTicketOrScanQR = 'Please select a ticket or scan a QR code with Ticket ID';
translations.en.confirmEntryProcess = 'Confirm: Proceed with entry process for this ticket?';
translations.en.enteredToTicket = 'Entered to {name}';
translations.en.processingError = 'Processing error';
translations.en.ticketDeleted = 'Selected ticket was deleted';
translations.en.newEntry = 'New entry';
translations.en.ticketIdScanned = 'Ticket ID scanned\n"{name}" selected';

translations.ko.allowExternalAccessDesc = '이 설정이 켜져 있으면 모바일 장치에 티켓 ID를 입력한 직원도 QR 코드를 스캔할 수 있습니다.';
translations.ko.externalScannerModeTitle = '외부 스캐너 모드';
translations.ko.scanQRCode = 'QR 코드 스캔';
translations.ko.scanTicketId = '티켓 ID 스캔';
translations.ko.selectedTicketQR = '("{name}"의 QR 코드)';
translations.ko.cameraError = '카메라 시작 실패. 카메라 액세스를 허용하세요.';
translations.ko.retry = '재시도';
translations.ko.holdQRToCamera = 'QR 코드를 카메라에 대세요';
translations.ko.qrScanConfirmToggle = 'QR 스캔 시 확인';
translations.ko.selectedTicketLabel = '【선택된 티켓】';
translations.ko.clearTicketSelection = '티켓 선택 지우기';
translations.ko.enterQRCode = '"{name}"의 QR 코드 입력';
translations.ko.enterTicketIdPrompt = '티켓 ID 입력';
translations.ko.qrCodePlaceholder = 'QR 코드 입력 (예: W7CFICB6)';
translations.ko.ticketIdPlaceholder = '티켓 ID 입력 (예: 5iuGByzlP8Yjfw6FWryh)';
translations.ko.execute = '실행';
translations.ko.scanResult = '스캔 결과';
translations.ko.successStatus = '성공';
translations.ko.failureStatus = '실패';
translations.ko.scannedValue = '스캔된 값';
translations.ko.cameraScan = '카메라 스캔';
translations.ko.scanHistory = '스캔 기록';
translations.ko.items = '개';
translations.ko.clearHistory = '기록 지우기';
translations.ko.searchPlaceholderHistory = 'QR 코드, 좌석 번호, 자유 텍스트로 검색...';
translations.ko.noSearchResults = '검색 결과 없음';
translations.ko.noScanHistory = '스캔 기록 없음';
translations.ko.usageInfo = '카메라로 QR 코드를 스캔하거나 QR 코드 또는 티켓 ID를 수동으로 입력하세요. 외부 액세스가 활성화된 티켓만 처리됩니다.';
translations.ko.ticketIdConfirm = '티켓 ID 확인';
translations.ko.alreadyScannedWarning = '이미 스캔됨';
translations.ko.continue = '계속';
translations.ko.initializationFailed = '초기화 실패';
translations.ko.enterQROrTicketId = 'QR 코드 또는 티켓 ID를 입력하세요';
translations.ko.ticketNotFound = '티켓을 찾을 수 없습니다. 티켓 ID를 확인하세요.';
translations.ko.ticketInfoFetchFailed = '티켓 정보 가져오기 실패';
translations.ko.ticketSelected = '티켓 "{name}"을(를) 선택했습니다. QR 코드를 스캔하세요.';
translations.ko.qrNotForSelectedTicket = '이 QR 코드는 선택된 티켓 "{name}"의 것이 아닙니다';
translations.ko.qrVerificationFailed = 'QR 코드 확인 실패';
translations.ko.selectTicketOrScanQR = '티켓을 선택하거나 티켓 ID가 포함된 QR 코드를 스캔하세요';
translations.ko.confirmEntryProcess = '확인: 이 티켓으로 입장 처리를 진행하시겠습니까?';
translations.ko.enteredToTicket = '{name}에 입장했습니다';
translations.ko.processingError = '처리 오류';
translations.ko.ticketDeleted = '선택된 티켓이 삭제되었습니다';
translations.ko.newEntry = '새 입장';
translations.ko.ticketIdScanned = '티켓 ID 스캔됨\n"{name}" 선택됨';

translations.zh.allowExternalAccessDesc = '当此设置为开启时，在移动设备上输入票券ID的工作人员也可以扫描二维码。';
translations.zh.externalScannerModeTitle = '外部扫描仪模式';
translations.zh.scanQRCode = '扫描二维码';
translations.zh.scanTicketId = '扫描票券ID';
translations.zh.selectedTicketQR = '（"{name}"的二维码）';
translations.zh.cameraError = '启动相机失败。请允许相机访问。';
translations.zh.retry = '重试';
translations.zh.holdQRToCamera = '将二维码对准相机';
translations.zh.qrScanConfirmToggle = '扫描二维码时确认';
translations.zh.selectedTicketLabel = '【选择的票券】';
translations.zh.clearTicketSelection = '清除票券选择';
translations.zh.enterQRCode = '输入"{name}"的二维码';
translations.zh.enterTicketIdPrompt = '输入票券ID';
translations.zh.qrCodePlaceholder = '输入二维码（例如：W7CFICB6）';
translations.zh.ticketIdPlaceholder = '输入票券ID（例如：5iuGByzlP8Yjfw6FWryh）';
translations.zh.execute = '执行';
translations.zh.scanResult = '扫描结果';
translations.zh.successStatus = '成功';
translations.zh.failureStatus = '失败';
translations.zh.scannedValue = '扫描的值';
translations.zh.cameraScan = '相机扫描';
translations.zh.scanHistory = '扫描历史';
translations.zh.items = '项';
translations.zh.clearHistory = '清除历史';
translations.zh.searchPlaceholderHistory = '按二维码、座位号、自由文本搜索...';
translations.zh.noSearchResults = '无搜索结果';
translations.zh.noScanHistory = '无扫描历史';
translations.zh.usageInfo = '使用相机扫描二维码或手动输入二维码或票券ID。仅处理启用外部访问的票券。';
translations.zh.ticketIdConfirm = '票券ID确认';
translations.zh.alreadyScannedWarning = '已扫描';
translations.zh.continue = '继续';
translations.zh.initializationFailed = '初始化失败';
translations.zh.enterQROrTicketId = '请输入二维码或票券ID';
translations.zh.ticketNotFound = '未找到票券。请检查票券ID。';
translations.zh.ticketInfoFetchFailed = '获取票券信息失败';
translations.zh.ticketSelected = '已选择票券"{name}"。请扫描二维码。';
translations.zh.qrNotForSelectedTicket = '此二维码不属于选择的票券"{name}"';
translations.zh.qrVerificationFailed = '二维码验证失败';
translations.zh.selectTicketOrScanQR = '请选择票券或扫描包含票券ID的二维码';
translations.zh.confirmEntryProcess = '确认：继续此票券的入场处理？';
translations.zh.enteredToTicket = '已入场到{name}';
translations.zh.processingError = '处理错误';
translations.zh.ticketDeleted = '选择的票券已被删除';
translations.zh.newEntry = '新入场';
translations.zh.ticketIdScanned = '票券ID已扫描\n已选择"{name}"';

// PDF Template Dialog
translations.ja.selectDesignTemplate = 'デザインテンプレートを選択';
translations.ja.enterTicketDesignInfo = 'チケットのデザインと情報を入力してください。';
translations.ja.designLabel = 'デザイン';
translations.ja.eventDateLabel = 'イベント日時（オプション）';
translations.ja.eventDatePlaceholder = '例: 2026年3月15日 18:00';
translations.ja.freeInputLabel = 'フリー入力欄（オプション）';
translations.ja.freeInputUsage = '使い方：';
translations.ja.freeInputNote1 = 'ここに入力した内容は、全てのチケットに共通で表示されます';
translations.ja.freeInputNote2 = '個別に設定したい場合：';
translations.ja.freeInputNote2Detail = 'チケットタブで「📋 CSVダウンロード」→ Excelで編集 → 「📥 CSVインポート」';
translations.ja.freeInputNote3 = 'CSVでフリー入力を設定した場合、CSVの内容が優先されます';
translations.ja.freeInputNote4 = '「HTMLで書く」チェックは、この欄とCSVの両方に適用されます';
translations.ja.freeInputPlaceholder = '座席番号、整理番号、注意事項など自由に入力';
translations.ja.freeInputPlaceholderHtml = 'HTMLタグを使用できます';
translations.ja.writeInHtml = 'HTMLで書く（タグを使用）';
translations.ja.htmlExample = '例: A-12<br>整理番号: 123、<b>太字</b>、<span style="color: red;">赤文字</span>';
translations.ja.plainTextExample = '例: A-12（改行は自動で反映されます）';
translations.ja.printLayoutLabel = '印刷レイアウト';
translations.ja.a4Layout = 'A4レイアウト';
translations.ja.a4LayoutDesc = 'A4用紙に2枚配置（切り取り用）';
translations.ja.singleLayout = '1枚ずつ';
translations.ja.singleLayoutDesc = '標準サイズで1枚ずつ印刷';
translations.ja.mobileLayout = '携帯用縦レイアウト';
translations.ja.mobileLayoutDesc = 'スマホ向け縦長デザイン';
translations.ja.previewButton = 'プレビュー';
translations.ja.generatePdfButton = 'PDF生成';
translations.ja.previewTitle = 'プレビュー';
translations.ja.closeButton = '閉じる';
translations.ja.generateWithDesign = 'このデザインでPDF生成';
translations.ja.pdfLayoutPrompt = 'PDFレイアウトを選択してください:\n\n1: 2列×5行 = 10個（大）\n2: 4列×5行 = 20個（中）\n3: 4列×6行 = 24個（小）\n\n1 / 2 / 3 を入力';
translations.ja.pdfLayoutGenerated = 'PDF を {layout} レイアウト で生成・ダウンロードしました';
translations.ja.generating = '生成中...';
translations.ja.sampleEvent = 'サンプルイベント';
translations.ja.pdfGeneratedA4 = 'デザイン付きPDF（A4レイアウト）を生成しました';
translations.ja.pdfGeneratedMobile = 'デザイン付きPDF（携帯用縦レイアウト）を生成しました';
translations.ja.pdfGeneratedSingle = 'デザイン付きPDF（1枚ずつ）を生成しました';

translations.en.selectDesignTemplate = 'Select Design Template';
translations.en.enterTicketDesignInfo = 'Enter ticket design and information.';
translations.en.designLabel = 'Design';
translations.en.eventDateLabel = 'Event Date (Optional)';
translations.en.eventDatePlaceholder = 'e.g., March 15, 2026 18:00';
translations.en.freeInputLabel = 'Free Input Field (Optional)';
translations.en.freeInputUsage = 'How to use:';
translations.en.freeInputNote1 = 'Content entered here will be displayed on all tickets';
translations.en.freeInputNote2 = 'To set individually:';
translations.en.freeInputNote2Detail = 'Tickets tab → "📋 CSV Download" → Edit in Excel → "📥 CSV Import"';
translations.en.freeInputNote3 = 'If free input is set in CSV, CSV content takes priority';
translations.en.freeInputNote4 = '"Write in HTML" checkbox applies to both this field and CSV';
translations.en.freeInputPlaceholder = 'Seat number, serial number, notes, etc.';
translations.en.freeInputPlaceholderHtml = 'HTML tags can be used';
translations.en.writeInHtml = 'Write in HTML (use tags)';
translations.en.htmlExample = 'e.g., A-12<br>Serial: 123, <b>bold</b>, <span style="color: red;">red text</span>';
translations.en.plainTextExample = 'e.g., A-12 (line breaks are automatically applied)';
translations.en.printLayoutLabel = 'Print Layout';
translations.en.a4Layout = 'A4 Layout';
translations.en.a4LayoutDesc = '2 tickets per A4 sheet (for cutting)';
translations.en.singleLayout = 'Single Sheet';
translations.en.singleLayoutDesc = 'Print one ticket per standard size sheet';
translations.en.mobileLayout = 'Mobile Portrait Layout';
translations.en.mobileLayoutDesc = 'Vertical design for smartphones';
translations.en.previewButton = 'Preview';
translations.en.generatePdfButton = 'Generate PDF';
translations.en.previewTitle = 'Preview';
translations.en.closeButton = 'Close';
translations.en.generateWithDesign = 'Generate PDF with this design';
translations.en.pdfLayoutPrompt = 'Select PDF layout:\n\n1: 2 cols × 5 rows = 10 QR codes (Large)\n2: 4 cols × 5 rows = 20 QR codes (Medium)\n3: 4 cols × 6 rows = 24 QR codes (Small)\n\nEnter 1 / 2 / 3';
translations.en.pdfLayoutGenerated = 'PDF generated with {layout} layout';
translations.en.generating = 'Generating...';
translations.en.sampleEvent = 'Sample Event';
translations.en.pdfGeneratedA4 = 'Generated designed PDF (A4 Layout)';
translations.en.pdfGeneratedMobile = 'Generated designed PDF (Mobile Portrait Layout)';
translations.en.pdfGeneratedSingle = 'Generated designed PDF (Single Sheet)';

translations.ko.selectDesignTemplate = '디자인 템플릿 선택';
translations.ko.enterTicketDesignInfo = '티켓 디자인 및 정보를 입력하세요.';
translations.ko.designLabel = '디자인';
translations.ko.eventDateLabel = '이벤트 날짜 (선택사항)';
translations.ko.eventDatePlaceholder = '예: 2026년 3월 15일 18:00';
translations.ko.freeInputLabel = '자유 입력란 (선택사항)';
translations.ko.freeInputUsage = '사용 방법:';
translations.ko.freeInputNote1 = '여기에 입력한 내용은 모든 티켓에 공통으로 표시됩니다';
translations.ko.freeInputNote2 = '개별 설정하려면:';
translations.ko.freeInputNote2Detail = '티켓 탭 → "📋 CSV 다운로드" → Excel에서 편집 → "📥 CSV 가져오기"';
translations.ko.freeInputNote3 = 'CSV에서 자유 입력을 설정한 경우 CSV 내용이 우선됩니다';
translations.ko.freeInputNote4 = '"HTML로 작성" 체크박스는 이 필드와 CSV 모두에 적용됩니다';
translations.ko.freeInputPlaceholder = '좌석 번호, 일련 번호, 주의사항 등';
translations.ko.freeInputPlaceholderHtml = 'HTML 태그를 사용할 수 있습니다';
translations.ko.writeInHtml = 'HTML로 작성 (태그 사용)';
translations.ko.htmlExample = '예: A-12<br>일련번호: 123, <b>굵게</b>, <span style="color: red;">빨간 텍스트</span>';
translations.ko.plainTextExample = '예: A-12 (줄 바꿈은 자동으로 적용됩니다)';
translations.ko.printLayoutLabel = '인쇄 레이아웃';
translations.ko.a4Layout = 'A4 레이아웃';
translations.ko.a4LayoutDesc = 'A4 용지에 2장 배치 (절단용)';
translations.ko.singleLayout = '한 장씩';
translations.ko.singleLayoutDesc = '표준 크기로 한 장씩 인쇄';
translations.ko.mobileLayout = '모바일 세로 레이아웃';
translations.ko.mobileLayoutDesc = '스마트폰용 세로 디자인';
translations.ko.previewButton = '미리보기';
translations.ko.generatePdfButton = 'PDF 생성';
translations.ko.previewTitle = '미리보기';
translations.ko.closeButton = '닫기';
translations.ko.generateWithDesign = '이 디자인으로 PDF 생성';
translations.ko.pdfLayoutPrompt = 'PDF 레이아웃 선택:\n\n1: 2열 × 5행 = 10개 (대)\n2: 4열 × 5행 = 20개 (중)\n3: 4열 × 6행 = 24개 (소)\n\n1 / 2 / 3 입력';
translations.ko.pdfLayoutGenerated = '{layout} 레이아웃으로 PDF 생성 완료';
translations.ko.generating = '생성 중...';
translations.ko.sampleEvent = '샘플 이벤트';
translations.ko.pdfGeneratedA4 = '디자인 PDF (A4 레이아웃) 생성 완료';
translations.ko.pdfGeneratedMobile = '디자인 PDF (모바일 세로 레이아웃) 생성 완료';
translations.ko.pdfGeneratedSingle = '디자인 PDF (한 장씩) 생성 완료';

translations.zh.selectDesignTemplate = '选择设计模板';
translations.zh.enterTicketDesignInfo = '输入票券设计和信息。';
translations.zh.designLabel = '设计';
translations.zh.eventDateLabel = '活动日期（可选）';
translations.zh.eventDatePlaceholder = '例如：2026年3月15日 18:00';
translations.zh.freeInputLabel = '自由输入栏（可选）';
translations.zh.freeInputUsage = '使用方法：';
translations.zh.freeInputNote1 = '此处输入的内容将显示在所有票券上';
translations.zh.freeInputNote2 = '要单独设置：';
translations.zh.freeInputNote2Detail = '票券选项卡 → "📋 CSV下载" → 在Excel中编辑 → "📥 CSV导入"';
translations.zh.freeInputNote3 = '如果在CSV中设置了自由输入，CSV内容优先';
translations.zh.freeInputNote4 = '"用HTML编写"复选框适用于此字段和CSV';
translations.zh.freeInputPlaceholder = '座位号、序列号、注意事项等';
translations.zh.freeInputPlaceholderHtml = '可以使用HTML标签';
translations.zh.writeInHtml = '用HTML编写（使用标签）';
translations.zh.htmlExample = '例如：A-12<br>序列号：123，<b>粗体</b>，<span style="color: red;">红色文本</span>';
translations.zh.plainTextExample = '例如：A-12（换行符会自动应用）';
translations.zh.printLayoutLabel = '打印布局';
translations.zh.a4Layout = 'A4布局';
translations.zh.a4LayoutDesc = '每张A4纸2张票券（用于裁剪）';
translations.zh.singleLayout = '单张';
translations.zh.singleLayoutDesc = '标准尺寸单张打印';
translations.zh.mobileLayout = '移动竖屏布局';
translations.zh.mobileLayoutDesc = '智能手机竖屏设计';
translations.zh.previewButton = '预览';
translations.zh.generatePdfButton = '生成PDF';
translations.zh.previewTitle = '预览';
translations.zh.closeButton = '关闭';
translations.zh.generateWithDesign = '使用此设计生成PDF';
translations.zh.pdfLayoutPrompt = '选择PDF布局:\n\n1: 2列 × 5行 = 10个 (大)\n2: 4列 × 5行 = 20个 (中)\n3: 4列 × 6行 = 24个 (小)\n\n输入 1 / 2 / 3';
translations.zh.pdfLayoutGenerated = '已生成 {layout} 布局的PDF';
translations.zh.generating = '生成中...';
translations.zh.sampleEvent = '示例活动';
translations.zh.pdfGeneratedA4 = '已生成设计PDF（A4布局）';
translations.zh.pdfGeneratedMobile = '已生成设计PDF（移动竖屏布局）';
translations.zh.pdfGeneratedSingle = '已生成设计PDF（单张）';

translations.ja.csvImportSuccess = 'CSVをインポートしました（{updated}件更新）';
translations.ja.csvImportPartial = 'CSVをインポートしました（{updated}/{total}件更新、{errors}件エラー）';
translations.ja.csvImportFailed = 'CSVインポートに失敗しました: {error}';

translations.en.csvImportSuccess = 'CSV imported ({updated} updated)';
translations.en.csvImportPartial = 'CSV imported ({updated}/{total} updated, {errors} errors)';
translations.en.csvImportFailed = 'CSV import failed: {error}';

translations.ko.csvImportSuccess = 'CSV 가져오기 완료 ({updated}건 업데이트)';
translations.ko.csvImportPartial = 'CSV 가져오기 완료 ({updated}/{total}건 업데이트, {errors}건 오류)';
translations.ko.csvImportFailed = 'CSV 가져오기 실패: {error}';

translations.zh.csvImportSuccess = 'CSV导入完成（已更新{updated}条）';
translations.zh.csvImportPartial = 'CSV导入完成（已更新{updated}/{total}条，{errors}条错误）';
translations.zh.csvImportFailed = 'CSV导入失败：{error}';

translations.ja.ticketNameSearch = 'チケット名検索';
translations.ja.sortNewest = '新しい順';
translations.ja.sortOldest = '古い順';
translations.ja.sortName = '名前順';
translations.ja.prevPage = '前へ';
translations.ja.nextPage = '次へ';

translations.en.ticketNameSearch = 'Search ticket name';
translations.en.sortNewest = 'Newest';
translations.en.sortOldest = 'Oldest';
translations.en.sortName = 'Name';
translations.en.prevPage = 'Prev';
translations.en.nextPage = 'Next';

translations.ko.ticketNameSearch = '티켓 이름 검색';
translations.ko.sortNewest = '최신순';
translations.ko.sortOldest = '오래된순';
translations.ko.sortName = '이름순';
translations.ko.prevPage = '이전';
translations.ko.nextPage = '다음';

translations.zh.ticketNameSearch = '搜索票券名称';
translations.zh.sortNewest = '最新';
translations.zh.sortOldest = '最旧';
translations.zh.sortName = '名称顺序';
translations.zh.prevPage = '上一页';
translations.zh.nextPage = '下一页';

// LocalStorage容量超過
translations.ja.storageQuotaExceeded = 'ローカルストレージの容量が上限を超えました。不要なチケットを削除してください。';
translations.en.storageQuotaExceeded = 'Local storage capacity exceeded. Please delete unnecessary tickets.';
translations.ko.storageQuotaExceeded = '로컬 저장소 용량이 초과되었습니다. 불필요한 티켓을 삭제하세요.';
translations.zh.storageQuotaExceeded = '本地存储容量已超出上限，请删除不需要的票券。';

// ゲストモード
translations.ja.guestMode = 'ゲストモード';
translations.ja.loginAsGuest = 'ゲストとして開始';
translations.ja.guestUser = 'ゲストユーザー';
translations.ja.guestLoginSuccess = 'ゲストモードで開始しました';
translations.ja.guestLoginFailed = 'ゲストモードの開始に失敗しました';
translations.ja.guestLogoutWarning = 'ゲストモードでログアウトすると、作成したチケットデータはすべて失われます。\nよろしいですか？';
translations.ja.linkAccount = 'アカウント連携';
translations.ja.linkAccountDesc = 'アカウントを連携するとデータが保存され、次回ログイン時に引き継がれます。';
translations.ja.linkWithGoogle = 'Googleアカウントと連携';
translations.ja.linkWithLine = 'LINEアカウントと連携';
translations.ja.alreadyLinkedError = 'このアカウントはすでに別のユーザーに連携されています';
translations.ja.linkSuccess = '{provider}アカウントと連携しました';
translations.ja.linkAlreadyLinked = 'すでに連携されています。連携しました。';
translations.ja.linkAlreadyLinkedWarning = 'このアカウントはすでに連携済みです。\nゲストとして作成したデータは消え、連携先のデータが優先されます。\n続けますか？';
translations.ja.linkFailed = '{provider}連携に失敗しました ({error})';

translations.en.guestMode = 'Guest Mode';
translations.en.loginAsGuest = 'Start as Guest';
translations.en.guestUser = 'Guest User';
translations.en.guestLoginSuccess = 'Started in guest mode';
translations.en.guestLoginFailed = 'Failed to start in guest mode';
translations.en.guestLogoutWarning = 'Logging out in guest mode will delete all your ticket data.\nAre you sure?';
translations.en.linkAccount = 'Link Account';
translations.en.linkAccountDesc = 'Linking an account saves your data and carries it over on next login.';
translations.en.linkWithGoogle = 'Link with Google';
translations.en.linkWithLine = 'Link with LINE';
translations.en.alreadyLinkedError = 'This account is already linked to a different user';
translations.en.linkSuccess = 'Linked with {provider} account';
translations.en.linkAlreadyLinked = 'Already linked. Linked successfully.';
translations.en.linkAlreadyLinkedWarning = 'This account is already linked.\nYour guest data will be lost and the linked account data will take priority.\nDo you want to continue?';
translations.en.linkFailed = 'Failed to link with {provider} ({error})';

translations.ko.guestMode = '게스트 모드';
translations.ko.loginAsGuest = '게스트로 시작';
translations.ko.guestUser = '게스트 사용자';
translations.ko.guestLoginSuccess = '게스트 모드로 시작했습니다';
translations.ko.guestLoginFailed = '게스트 모드 시작에 실패했습니다';
translations.ko.guestLogoutWarning = '게스트 모드에서 로그아웃하면 모든 티켓 데이터가 삭제됩니다.\n계속하시겠습니까?';
translations.ko.linkAccount = '계정 연동';
translations.ko.linkAccountDesc = '계정을 연동하면 데이터가 저장되어 다음 로그인 시 이어서 사용할 수 있습니다.';
translations.ko.linkWithGoogle = 'Google 계정 연동';
translations.ko.linkWithLine = 'LINE 계정 연동';
translations.ko.alreadyLinkedError = '이 계정은 이미 다른 사용자에게 연동되어 있습니다';
translations.ko.linkSuccess = '{provider} 계정과 연동되었습니다';
translations.ko.linkAlreadyLinked = '이미 연동되어 있습니다. 연동했습니다.';
translations.ko.linkAlreadyLinkedWarning = '이 계정은 이미 연동되어 있습니다.\n게스트로 만든 데이터는 사라지고 연동된 계정의 데이터가 우선됩니다.\n계속하시겠습니까?';
translations.ko.linkFailed = '{provider} 연동에 실패했습니다 ({error})';

translations.zh.guestMode = '访客模式';
translations.zh.loginAsGuest = '以访客身份开始';
translations.zh.guestUser = '访客用户';
translations.zh.guestLoginSuccess = '已以访客模式开始';
translations.zh.guestLoginFailed = '访客模式启动失败';
translations.zh.guestLogoutWarning = '在访客模式下退出将删除所有票务数据。\n确定要继续吗？';
translations.zh.linkAccount = '关联账户';
translations.zh.linkAccountDesc = '关联账户后，您的数据将被保存，并在下次登录时继承。';
translations.zh.linkWithGoogle = '关联Google账户';
translations.zh.linkWithLine = '关联LINE账户';
translations.zh.alreadyLinkedError = '该账户已与其他用户关联';
translations.zh.linkSuccess = '已与{provider}账户关联';
translations.zh.linkAlreadyLinked = '已关联。关联成功。';
translations.zh.linkAlreadyLinkedWarning = '该账户已关联。\n访客数据将消失，以关联账户的数据为准。\n要继续吗？';
translations.zh.linkFailed = '与{provider}关联失败 ({error})';
